module.exports = __webpack_public_path__ + "img/shops_mins_landing_page.697eb292.jpg";